var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlasOneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3222 11.1921C16.771 10.8734 16.0671 11.063 15.749 11.6135L7.28581 26.2714C6.96709 26.8226 7.15609 27.5272 7.70726 27.8452C7.88901 27.9499 8.08657 28 8.28215 28C8.68055 28 9.06709 27.7932 9.28045 27.4238L17.743 12.7653C18.0617 12.2147 17.8734 11.5101 17.3222 11.1921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4626 16.6314C19.9107 16.312 19.2068 16.5017 18.8887 17.0528L13.5666 26.2714C13.2479 26.8225 13.4375 27.5272 13.9881 27.8452C14.1698 27.9499 14.368 28 14.5629 28C14.9613 28 15.3486 27.7932 15.5619 27.4238L20.8847 18.2052C21.2027 17.6541 21.0137 16.9494 20.4626 16.6314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6011 22.0674C23.0499 21.7487 22.3453 21.9377 22.0272 22.4889L19.8436 26.2714C19.5249 26.8226 19.7139 27.5272 20.2651 27.8452C20.4468 27.9499 20.6444 28 20.8399 28C21.2383 28 21.6249 27.7932 21.8389 27.4238L24.0232 23.6413C24.3413 23.0901 24.1523 22.3855 23.6011 22.0674Z",
    fill: "#10AEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0265 5.04619L19.0258 5.04553C18.424 4.00376 16.16 0 16.16 0C16.16 0 13.8618 4.00376 13.2606 5.04553L12.7943 5.85287L10.7819 9.34233H10.7865C10.4935 9.88824 10.6825 10.5711 11.2225 10.8826C11.4042 10.988 11.6024 11.0373 11.7973 11.0373C12.1957 11.0373 12.5823 10.8306 12.7957 10.4611L15.4455 5.85287L16.1481 4.62935L29.5897 28H32.2475L19.0265 5.04619Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.496 14.4406H10.4941C10.7924 13.8933 10.6067 13.2065 10.0634 12.8937C9.51223 12.575 8.80828 12.7646 8.49022 13.3152L0 28H2.6604L10.496 14.4406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasOneLogo);
export default __webpack_public_path__ + "static/media/atlas-one-logo.0fcd3aa89527c48332050b888ef57095.svg";
export { ForwardRef as ReactComponent };